/**
 * 字符串截取前后 中间字符隐藏
 * @param str
 * @param replaceValue
 */
export function stringReplaceMiddleChars(str: string, replaceValue = '****') {
    return `${str.charAt(0) || '*'}${replaceValue}${str.charAt(str.length - 1) || '*'}`;
}

/**
 * 去掉# hash值
 * @param str
 */
export function removeHash(str) {
    return str.replace(/#.*$/, '');
}

/**
 * 判断目标字符串是否 包含有或等于 数组中某个字符串
 * @param {string} target - 目标字符串
 * @param {string[]} strArray - 字符串数组
 * @returns {boolean} 存在则返回true，否则返回false
 */
export function isStringIncludedArrayString(target: string, strArray: string[]): boolean {
    // 使用some()方法检查数组中是否有符合条件的元素
    return strArray.some((str: string) => {
        // 检查目标字符串是否包含或等于当前元素字符串
        return target.includes(str) || str === target;
    });
}


/**
 * 处理字符串替换变量为组件的
 * @param str
 * @param replacements
 */
export const replacePlaceholderWithComponent = (
    str: string,
    replacements: Record<string, (string | React.ReactNode)>
): (string | React.ReactNode)[] => {
    // 正则匹配 {{变量名}} 格式的占位符（捕获组保留占位符内容）
    const parts = str.split(/({{\w+}})/);

    // 遍历分割后的片段，替换占位符为组件
    return parts.map((part, index) => {
        // 提取占位符中的变量名（如从{{logo}}中提取logo）
        const match = part.match(/{{(\w+)}}/);
        if (match) {
            const key = match[1]; // 变量名（如logo）
            // 从替换映射中获取对应组件，若不存在则保留原始占位符
            return replacements[key] || part;
        }
        // 普通文本直接返回
        return part;
    });
};